import { Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom'
import { getUserId } from '@/store/userStore'
import { MainLayout } from '@/layout/MainLayout'
import { Dashboard } from '@/layout/Dashboard'
import { NotFound } from '@/pages/NotFound'
import { Profile } from '@/pages/Profile'
import { Income } from '@/pages/Income'
import { Connections } from '@/pages/BankConnections'
import { Institutions } from '@/pages/Institutions'
import { InstitutionDetail } from '@/pages/Institutions/InstitutionDetail'
import { Products } from '@/pages/Products'
import { Transactions } from '@/components/Transactions'
import { LoanApplications } from '@/components/LoanApplications'
import { Loans } from '@/components/Loans'
import { Eligibility } from '@/components/Eligibilty'
import { Developer } from '@/pages/Developer'
import { PlatformPermission } from '@/domain/permissions/rbac'
import { PermissionRoute } from './PermissionRoute'
import { isLowerEnvironment } from '@/utils/constants'

const ProtectedRoute = () => {
  const userId = getUserId()
  const location = useLocation()

  if (!userId) {
    // Redirect to /app but store the current location so we can go back later
    return <Navigate to="/app" state={{ from: location }} replace />
  }

  return <Outlet />
}

export const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<Navigate to="/app" replace />} />
        <Route path="/app" element={<Dashboard />} />

        <Route element={<ProtectedRoute />}>
          <Route
            path="/profile"
            element={
              <PermissionRoute permission={PlatformPermission.ViewUser}>
                <Profile />
              </PermissionRoute>
            }
          />
          <Route
            path="/income"
            element={
              <PermissionRoute permission={PlatformPermission.ViewUser}>
                <Income />
              </PermissionRoute>
            }
          />
          <Route
            path="/connections"
            element={
              <PermissionRoute permission={PlatformPermission.ManageBankConnections}>
                <Connections />
              </PermissionRoute>
            }
          />
          <Route path="/transactions" element={<Transactions />} />
          <Route
            path="/applications"
            element={
              <PermissionRoute permission={PlatformPermission.ManageLoanApplication}>
                <LoanApplications />
              </PermissionRoute>
            }
          />
          <Route
            path="/loans"
            element={
              <PermissionRoute permission={PlatformPermission.ManageLoan}>
                <Loans />
              </PermissionRoute>
            }
          />
          <Route path="/eligibility" element={<Eligibility />} />
        </Route>

        {/* Bank institutions — global list, no customer needs to be selected */}
        <Route
          path="/institutions"
          element={
            <PermissionRoute permission={PlatformPermission.Support}>
              <Institutions />
            </PermissionRoute>
          }
        />
        <Route
          path="/institutions/:institutionId"
          element={
            <PermissionRoute permission={PlatformPermission.Support}>
              <InstitutionDetail />
            </PermissionRoute>
          }
        />

        {/* Product configurations — global catalogue, no customer needed, and
            open to every role: it is reference data with nothing
            customer-specific on it. */}
        <Route path="/products" element={<Products />} />

        {/* Developer Tools — does not require a customer to be selected */}
        {isLowerEnvironment() && (
          <Route
            path="/developer"
            element={
              <PermissionRoute permission={PlatformPermission.DeveloperTools}>
                <Developer />
              </PermissionRoute>
            }
          />
        )}
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
